module.exports = __webpack_public_path__ + "images/72f3a613.png";